import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType } from '../../../redux/slices/modal';
import { ScheduleType } from '../../../utils/apollo/graphqlSchema';
import Scheduler from '../../../components/Scheduler';
import {
  DashboardDeleteReportModal,
  DashboardDuplicateReportModal,
} from '../components';
import ReportSearchModal from '../../../components/ReportSearchModal';
import RemoveDashboardFilterModal from './components/DashboardCustomizations/RemoveDashboardFilterModal';

interface IProps {
  dashboardBaseId: string;
}

const DashboardInstanceModalController = ({ dashboardBaseId }: IProps) => {
  const isScheduleCreateModalOpen = useAppSelector((state) =>
    selectOpenedModalType(
      state,
      ModalSliceType.CreateSchedule,
      `dashboard-${dashboardBaseId}`,
    ),
  );
  const isDeleteReportModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardDeleteReport, ''),
  );
  const isAddExistingReportsOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.ReportsSearch, 'dashboard'),
  );
  const isDuplicateReportModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardDuplicateReport, ''),
  );
  const isDeleteFilterModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardRemoveFilter, ''),
  );

  if (isScheduleCreateModalOpen) {
    return (
      <Scheduler entityId={dashboardBaseId} jobType={ScheduleType.Dashboard} />
    );
  }

  if (isDeleteReportModalOpen) {
    return <DashboardDeleteReportModal />;
  }

  if (isAddExistingReportsOpen) {
    return <ReportSearchModal type="add-report" />;
  }

  if (isDuplicateReportModalOpen) {
    return <DashboardDuplicateReportModal />;
  }

  if (isDeleteFilterModalOpen) {
    return <RemoveDashboardFilterModal />;
  }

  return null;
};

export default DashboardInstanceModalController;
